// scroll to top
window.scrollBy({
  top: 10, // could be negative value
  left: 0,
  behavior: "smooth",
});

const topBtn = document.querySelector("#top")
if(topBtn) {
  topBtn.scrollIntoView({
    behavior: "smooth",
  });
}

// Mobile Overlay Navigation
const page = document.querySelector(".js-page");
const navBurger = document.querySelector(".js-nav");

// mobile nav toggle
const navItem = document.querySelectorAll(".js-nav-dropdown");
navItem.forEach((item) => {
  item.addEventListener(
    "click",
    (event) => {
      event.currentTarget.classList.toggle("is-open");
    },
    false
  );
});

// VCard toggle
const vcard = document.querySelectorAll(".js-vcard");
vcard.forEach((item) => {
  item.addEventListener(
    "click",
    (event) => {
      event.currentTarget.classList.toggle("is-open");
    },
    false
  );
});

var filters_active = {}

// autocomplete - select
const program = [
  "Allgemein",
  "»Angebote Mentale Gesundheit«",
  "»Apollonia NÖ«",
  "Universitätslehrgang »Regionale Gesundheitskoordination«",
  "»Bewegte Klasse Grundstufe«",
  "»Bewegte Klasse« Sekundarstufe 1",
  "Aufbaumodul »Bewegte Klasse macht Schule«",
  "»Gesunder Betrieb«",
  "»Gesunde Gemeinde«",
  "»Gesunder Gemeindebetrieb«",
  "»Gesunde Schule«",
  "»H2NOE« – Wasserschule in NÖ",
  "»Los geht’s! Jeder Schritt tut gut«",
  "»Netzwerk Gesund im Kindergarten«",
  "»Netzwerk Familie«",
  "»Treff.Punkt.Gesundheit«",
  "»tut gut«-Wanderweg",
  "»tut gut«-Wirt",
  "»tut gut«-Schritteweg",
  "»Vitalküche«",
  "»Vitalküche« in den NÖ Kliniken",
  "»Vorsorge Aktiv«",
  "»Vorsorge Aktiv Junior«",
];

const town = [
  "Amstetten",
  "Baden",
  "Bruck",
  "Gmünd",
  "Gänserndorf",
  "Hausbrunn",
  "Hollabrunn",
  "Horn",
  "Korneuburg",
  "Krems",
  "Krems",
  "Ladendorf",
  "Lilienfeld",
  "Melk",
  "Mistelbach",
  "Mödling",
  "Neunkirchen",
  "Sankt",
  "Sankt",
  "Steinakirchen am Forst",
  "Scheibbs",
  "Tulln",
  "Waidhofen",
  "Waidhofen",
  "Wiener",
  "Wiener",
  "Zwettl",
];

initAccessibleAutocomplete("program", "events", program, "Programm wählen", "Keine Programme gefunden.")
initAccessibleAutocomplete("town", "events", town, "Ort wählen", "Keine Orte gefunden.")


const zielgruppe = [
  "Kinder",
  "Erwachsene",
  "Senioren"
];

const jahreszeit = [
  "Frühling",
  "Sommer",
  "Herbst",
  "Winter"
];

const categorytipps = [
  "Indoor",
  "Outdoor",
  "Rezepte",
  "Spiele",
  "Übungen",
  "Wandern",
  "Zitate"
];

initAccessibleAutocomplete("zielgruppe", "gesundheitstipps", zielgruppe, "Zielgruppe wählen", "Keine Zielgruppe gefunden.")
initAccessibleAutocomplete("jahreszeit", "gesundheitstipps", jahreszeit, "Jahreszeit wählen", "Keine Jahreszeit gefunden.")
initAccessibleAutocomplete("categorytipps", "gesundheitstipps", categorytipps, "Suche verfeinern")

/**
 * init accessibleAutocomplete plugin for given data
 * @param {string} name 
 * @param {Array} source 
 * @param {String} filterkey 
 * @param {String} placeholder 
 * @param {String} tNoResultsText 
 * @returns 
 */
function initAccessibleAutocomplete(name, filterkey, source, placeholder, tNoResultsText) {
  if(typeof name === undefined || name == "") throw new Error("name is required")
  if(typeof filterkey === undefined || filterkey == "") throw new Error("filterkey is required")
  if(typeof source === undefined || !Array.isArray(source)) throw new Error("source is required")

  const el = document.querySelector(".js-select-" + name)
  if(el) {
    if(typeof placeholder === undefined || placeholder == "") placeholder = "Kategorie wählen"
    if(typeof tNoResultsText === undefined || tNoResultsText == "") tNoResultsText = "Keine Ergebnisse gefunden."

    accessibleAutocomplete({
      element: el,
      id: "select-" + name, // To match it to the existing <label>.
      source: source,
      showAllValues: true,
      placeholder: "- " + placeholder + " -",
      onConfirm: (autocompleteval) => onAutocompleteConfirm(filterkey, name, autocompleteval),
      dropdownArrow: () => "",
      tNoResults: () => { return tNoResultsText }
    });
  }

}

// Filterbtn toggle
const filterbtns = document.querySelectorAll(".c-btn--filter");
filterbtns.forEach((item) => {
  item.addEventListener(
    "click",
    (event) => {
      let currentitem = event.currentTarget
      let filterkey = item.parentElement.dataset.filterkey
      if(filters_active[filterkey] === undefined) filters_active[filterkey] = {}

      if(currentitem.classList.contains("is-active")) {
        delete filters_active[filterkey]["filter"]
        setCardFilter(filterkey)
      }
      else {
        let btns = currentitem.parentElement.querySelectorAll('.c-btn--filter') // only siblings
        btns.forEach(btn => btn.classList.remove("is-active")) 
        setCardFilter(filterkey, "filter", currentitem.dataset.filter)
      }
      currentitem.classList.toggle("is-active")
    },
    false
  );
});

/**
 * filters Cards on Confirm of Autocomplete
 * additionally checks if selectbox is empty to reset cards
 * @param {string} filterkey
 * @param {string} autocompleteval 
 * @param {string} name 
 */
function onAutocompleteConfirm(filterkey, name, autocompleteval) {
  if(typeof filterkey === undefined || filterkey == "") throw new Error("filterkey is required")
  if(typeof name === undefined || name == "") throw new Error("name is required")

  if(filters_active[filterkey] === undefined) filters_active[filterkey] = {}
  
  if(autocompleteval) {
    // only numbers and letters
    let regex = /[^A-Za-z0-9]+/g
    autocompleteval = autocompleteval.replace(regex, "").toLowerCase()
    setCardFilter(filterkey, name, autocompleteval)
  }
  else if(document.querySelector('#select-' + name).value === "") {
    // check value of input field
    delete filters_active[filterkey][name]
    setCardFilter(filterkey)
  }
}

/**
 * displays cards according to set filters
 * @param {string} filterkey 
 * @param {string} datakey 
 * @param {string} val 
 */
 function setCardFilter(filterkey, datakey, val) {
  if(typeof filterkey === undefined || filterkey == "") throw new Error("filterkey is required")

  if(filters_active[filterkey] === undefined) filters_active[filterkey] = {}
  if(datakey && val) filters_active[filterkey][datakey] = val
  if(val == "") delete filters_active[filterkey][datakey]

  let cards = document.querySelectorAll(".js-grid--" + filterkey + " .c-card")
  let emptymessage_container = document.querySelector(".js-emptymessage--" + filterkey)
  let filtertexts = document.querySelectorAll(".js-filtertext--" + filterkey)

  cards.forEach(card => card.classList.remove("is-hidden"))
  emptymessage_container.classList.add("is-hidden")
  if(filtertexts) filtertexts.forEach(text => text.classList.add('is-hidden'))

  let keys = Object.keys(filters_active[filterkey])
  if(keys.length > 0) {
    keys.forEach((key) => {
      let filtertext = document.querySelector(".js-filtertext--" + val)
      if(filtertext) filtertext.classList.remove('is-hidden')

      cards.forEach(card => {
        if(card.dataset[key] != filters_active[filterkey][key]) {
          card.classList.add("is-hidden")
        }
      })
    })
  }

  /* display empty message if no results found */
  let cardsVisibleCnt = document.querySelectorAll(".js-grid--" + filterkey + " .c-card:not(.is-hidden)").length
  if(cardsVisibleCnt > 0) emptymessage_container.classList.add("is-hidden")
  else emptymessage_container.classList.remove("is-hidden")
}

const btnKostenfreiLiefern = document.querySelector("#btn-kostenfreiliefern")
if(btnKostenfreiLiefern) {
  btnKostenfreiLiefern.addEventListener(
    "click",
    (event) => {
      let sectionKostenfreiLiefern = document.querySelector("#section-kostenfreiliefern")
      sectionKostenfreiLiefern.classList.remove("is-hidden")
      
      // scroll form into view
      let headerHeight = document.querySelector(".o-header").offsetHeight
      let sectionTop = sectionKostenfreiLiefern.offsetTop
      window.scrollTo({
        top: sectionTop - headerHeight - 50
      })
    },
    false
  );
}